import { CollectionType } from '../../../../data-layer/collections/service';
import { SubcategoriesValue, TabsValue } from '../constants';

export const getTabsValue = (pathname: string, query: URLSearchParams, isWideProfile?: boolean) => {
    if (isWideProfile) {
        if (pathname.includes('collections')) {
            return {
                tabsValue:
                    query.get('collectionType') === CollectionType.SAVED
                        ? TabsValue.SAVED_COLLECTIONS
                        : TabsValue.COLLECTIONS,
            };
        }

        if (pathname.includes('moderation')) {
            return {
                tabsValue: TabsValue.MODERATION,
            };
        }

        return {
            tabsValue: TabsValue.POSTS,
        };
    }

    if (pathname.includes('collections')) {
        return {
            tabsValue: TabsValue.COLLECTIONS,
            subcategoriesValue:
                query.get('collectionType') === CollectionType.SAVED
                    ? SubcategoriesValue.SAVED
                    : SubcategoriesValue.CREATED,
        };
    }

    return {
        tabsValue: TabsValue.POSTS,
        subcategoriesValue: pathname.includes('moderation')
            ? SubcategoriesValue.MODERATION
            : SubcategoriesValue.POSTS,
    };
};
